import { render } from "./EffectView.vue?vue&type=template&id=c3d92a04&scoped=true&ts=true"
import script from "./EffectView.vue?vue&type=script&lang=ts"
export * from "./EffectView.vue?vue&type=script&lang=ts"

import "./EffectView.vue?vue&type=style&index=0&id=c3d92a04&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d92a04"]])

export default __exports__